import { HttpEventType } from '@angular/common/http';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PatientHistoryEntry } from 'src/app/data/patient-history-entry';
import { TokenPermissions } from 'src/app/data/permissions';
import { Study } from 'src/app/data/study';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { BookService } from 'src/app/services/book.service';
import { ConfigService } from 'src/app/services/config.service';
import { HelpService } from 'src/app/services/help.service';
import { PatientHistoryService } from 'src/app/services/patient-history.service';
import { PermissionService } from 'src/app/services/permission.service';
import { StudiesService } from 'src/app/services/studies.service';
import { environment } from 'src/environments/environment';
import { ContactImageComponent } from '../contact-image/contact-image.component';


import { TourService } from 'src/app/services/tour.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { DownloadModalComponent } from '../download-modal/download-modal.component';
import { clear } from 'console';
import { CookieService } from 'ngx-cookie-service';
//import { Observable } from 'rxjs/internal/Observable';



@Component({
  selector: 'app-side-options-desktop',
  templateUrl: './side-options-desktop.component.html',
  styleUrls: ['./side-options-desktop.component.css'],
})
export class SideOptionsDesktopComponent implements OnInit, AfterViewInit {

  @Input() caducityTime!: Date;
  @Input() token!: string;
  locator?: string;
  @Output('onClickShare') onClickShareEmitter = new EventEmitter<string>();
  @Output('onClickRenew') onClickRenewEmitter = new EventEmitter<void>();
  @Output('initDesktopTour') onClickHelpEmitter = new EventEmitter<void>();
  @Output('stepBackToVisor') stepBackEmitter = new EventEmitter<void>();

  @ViewChild(DownloadModalComponent) downloadModal!: DownloadModalComponent;

  environment = environment;
  window = window;
  canRenewCaducity: boolean = false;

  //subscription: Subscription; // Observer para poder abrir y cerrar el menú de opciones desde el tour

  isTourActive: boolean = false;

  showLogin: boolean = false;

  @ViewChild(ContactImageComponent) contactImage!: ContactImageComponent;


  historic: PatientHistoryEntry[] = [];
  get historicWithoutFirst() {
    return this.historic.filter((st, index) => index != 0)


  }
  get showRadiologist() {
    if (this.configService?.config?.show_radiologist != null)
      return this.configService.config.show_radiologist;
    else
      return false;
  }
  bookStudies: Study[] = [];

  opened: boolean = true;
  downloading: { studyUID: string | null, percentage: number } | null = null
  obtaining: Set<string> = new Set();

  TokenPermissions = TokenPermissions;

  studyHistoricLoaded: boolean = false;

  constructor(
    public tourService: TourService,
    private historyService: PatientHistoryService,
    private studiesService: StudiesService,
    private alertService: AlertService,
    private authService: AuthService,
    public configService: ConfigService,
    public permissionService: PermissionService,
    public bookService: BookService,
    public helpService: HelpService,
    private historicService: PatientHistoryService,
    private cookieService: CookieService
  ) {

  }

  ngOnInit(): void {

    if (this.token == null) {
      setTimeout(() => {
        this.ngOnInit();
      }, 100);
      return;
    }


    this.studiesService.getStudiesByToken(this.token).then(sts => {
      // console.log('this.bookStudies', sts);
      this.bookStudies = sts;
      this.historyService.loadHistoryForBookToken(this.token).then(entries => {
        // console.log('historic1', entries);
        this.historic = entries.filter(s => this.bookStudies.findIndex(st => st.studyUID == s.studyUID) == -1);
        this.historic.sort((a, b) => b.date!.getTime() - a.date!.getTime());
        console.log('historic2', this.historic);
      }).catch(error => {
        console.error(error);
      })
    }).catch(error => {
      console.error(error);
    })

    const calculateRenewLoop = () => {
      this.calculateCanRenewCaducity().catch(err => {
        setTimeout(() => {
          calculateRenewLoop()
        }, 500);
      }).then(res => console.log('this.canRenewCaducity', this.canRenewCaducity))
    }

    calculateRenewLoop();

    this.bookService.getLocatorByToken(this.token).then(locator => {
      this.locator = locator;
    }).catch(error => {
      console.error(error);
    })


  }

  ngAfterViewInit(): void {
    if (!this.tourService.globalVariables.isPageSmall) {
      //this.tourService.afterViewInit(false);
      //this.tourService.afterViewInit();
      //this.tourService.guideTour.isActive()
    } else {
      //this.showHelp();
    }
  }

  open() {
    this.opened = true;
  }

  close() {
    this.opened = false;
  }

  toggleCollapse() {
    this.opened = !this.opened;

  }

  onClickShare() {

    this.onClickShareEmitter.emit(this.locator);

  }

  onClickRenew() {
    this.onClickRenewEmitter.emit();
    setTimeout(() => {
      this.calculateCanRenewCaducity()
    }, 3000);
  }


  onClickDownloadModal(){
    this.downloadModal.open();
  }

  onClickDownload(study?: PatientHistoryEntry) {
    let studyUIDs: string[] = [];
    if (study != null) {
      studyUIDs = [study.studyUID!];
    } else {
      studyUIDs = this.bookStudies.map(st => st.studyUID!);
    }
    if (studyUIDs.length == 0) {
      this.alertService.alert('No se ha encontrado el estudio. Por favor, póngase en contacto con el centro hospitalario');
      return;
    }
    this.downloadStudies(studyUIDs);
  }

  async onClickSeeStudy(study?: PatientHistoryEntry) {
    let studyUID: string | null = null;
    if (study != null) {
      studyUID = study.studyUID;
    } else {
      studyUID = this.bookService.currentBook!.studyUIDs[0]
    }
    if (studyUID == null) {
      this.alertService.alert('No se ha encontrado el estudio. Por favor, póngase en contacto con el centro hospitalario');
      return;
    }
    
    try {
      const token = await this.bookService.askForToken(this.token);
      console.log('token recibido:', token);
      console.log('studyUID:', studyUID);
      this.configService.getConfig().then(c => {
        const route = c.visorRoute + `?sid=${studyUID}&ustkn=${token}`;
        console.log('route; ', route);
        let visorWindow = window.open(route, 'Visor', 'toolbar=no,top=10,left=10,width=' + (screen.width - 50) + ',height=' + (screen.height - 100));
        if (study == null && this.bookStudies.length > 1) { // si se ha hecho click en el general y hay más de un estudio en el book
          // Enviamos los estudios de uno en uno cada 1.5s
          setTimeout(() => {
            const sendNext = (index: number) => {
              if (index >= this.bookStudies.length)
                return;
              const st = this.bookStudies[index];
              const data = {
                order: 'loadSerie',
                data: { studyUID: st.studyUID }
              };
              visorWindow?.postMessage(data, '*');
              setTimeout(() => {
                sendNext(++index)
              }, 1500);
            }
            sendNext(1);
          }, 3000);
        }
      })
    } catch (error) {
      console.error('Error obteniendo token:', error);
      this.alertService.alert('Error al obtener el token de acceso');
    }
  }

  downloadStudies(studyUIDs: string[]) {
    if (this.downloading == null) {
      this.downloading = { studyUID: (studyUIDs.length == 1) ? studyUIDs[0] : null, percentage: 0 }
      setTimeout(() => {
        if (environment.demo) {
          const interval = setInterval(() => {
            if (++this.downloading!.percentage == 100) {
              clearInterval(interval);
              this.downloading = null;
            }
          }, 75)
        } else {
          let startedDownloading = false;
          const randomIntFromInterval = (min, max) => { // min and max included 
            return Math.floor(Math.random() * (max - min + 1) + min)
          }
          const interval = setInterval(() => {
            if (startedDownloading) {
              clearInterval(interval);
            } else {
              if (this.downloading!.percentage < 10) {
                this.downloading!.percentage += (randomIntFromInterval(0, 30) / 100) // ~ 1m 15s
              } else if (this.downloading!.percentage < 20) {
                this.downloading!.percentage += (randomIntFromInterval(10, 30) / 100) // ~ 1m
              } else if (this.downloading!.percentage < 30) {
                this.downloading!.percentage += (randomIntFromInterval(10, 50) / 100) // ~ 35s
              } else if (this.downloading!.percentage < 35) {
                this.downloading!.percentage += (randomIntFromInterval(0, 10) / 100) // ~ 1m 50s
              } else if (this.downloading!.percentage < 50) {
                this.downloading!.percentage += (randomIntFromInterval(0, 7) / 100) // ~ 8m
              }
            }
          }, 1200);
          this.studiesService.downloadStudies(studyUIDs).subscribe(event => {
            if (event!.type == HttpEventType.DownloadProgress) {
              startedDownloading = true;
              const percentage = ((event!.loaded / event!.total!) * 50) + 50
              console.log('percentage: ', percentage);
              this.downloading!.percentage = Math.round(percentage)
            }
            if (event!.type == HttpEventType.Response) {
              const link = document.createElement('a');
              if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                const url = URL.createObjectURL(event!.body!);
                link.setAttribute('href', url);
                link.setAttribute('download', "dicomdir.zip");
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
              this.downloading = null;
            }
          })
        }
      }, 1);
    } else {
      this.alertService.alert('Ya se está descargando un estudio. Por favor, espere a que finalice')
    }
  }

  onClickOpenBook(book: PatientHistoryEntry) {
    if (book != null) {
      console.log(book);
      console.log(book.studyToken);

      const patientSession = this.cookieService.get('patient_session');
      if (patientSession != null && patientSession != '') {
        // Renovar por 2 horas más
        this.cookieService.set('patient_session', patientSession, 
          undefined, '/', undefined, true, 'Strict');
      }

      this.bookService.addBookIDToSession(localStorage.getItem('DBAuthTkn'), book.studyToken).then(() => {
        const url = `/books/acceso?tkn=${book.studyToken}`;
        // window.open(url, '', 'toolbar=no,top=10,left=10,width=' + (screen.width - 50) + ',height=' + (screen.height - 100));
        this.window.location.href = url;
      }).catch(error => {
        console.error('Error adding book ID to session:', error);
      });
    }
  }

  showContact() {
    this.contactImage.open();
  }

  calculateCanRenewCaducity(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        if (this.caducityTime == null) {
          reject()
        } else {
          this.configService.systemConfig.then(c => {
            const expiringDateFromNow = new Date();
            expiringDateFromNow.setDate(expiringDateFromNow.getDate() + c.expiringTimeRenewal!)
            console.log('this.caducityTime', this.caducityTime);
            console.log('expiringDateFromNow', expiringDateFromNow);
            // Le sumamos 12 horas a la fecha de caducidad para que no permita renovar si justo has renovado ahora
            if (this.caducityTime.getTime() + (12 * 60 * 60 * 1000) < expiringDateFromNow.getTime()) {
              this.canRenewCaducity = true
              resolve()
            } else {
              this.canRenewCaducity = false
              resolve()
            }
          })
        }
      } catch (error) {
        reject(error)
      }
    })

  }

  onClickStartTour() {

    this.tourService.initDesktopTour();

    this.onClickHelpEmitter.emit()

    this.toggleCollapse();

  }

  addLastStep() {

    this.tourService.guideTour.addSteps([

      {
        id: "btn-11",
        attachTo: {
          element: '#book-digital-container > app-book-pdf-flipbook-landscape > app-side-options-desktop > div > div.btns-tour',
          on: "right"

        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              this.toggleCollapse();
              ($("#flipbook") as any).turn("page", 2);
              this.stepBackEmitter.emit();
              setTimeout(() => {
                this.tourService.guideTour.back();
              }, 200);

            }
          },
          {
            classes: 'tour-round-button',
            text: "Finalizar",
            action: () => {
              this.tourService.guideTour.complete();
            }
          }
        ],
        classes: "shepherd-text tour-container",
        modalOverlayOpeningPadding: 15,
        canClickTarget: false,
        text: "<p>Estas son las opciones de mayor utilidad para el usuario:</p>" +
          '<p>Descargar DICOM <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#e8eaed" style="margin-bottom:1px;"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg> Muestra las opciones de descarga del estudio</p>' +
          '<p>Ver estudio <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#e8eaed" style="margin-bottom:1px;"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg> Abre un visor de imágenes DICOM en una ventana externa</p>' +
          '<p>Compartir <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#e8eaed" style="margin-bottom:1px;"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg> Muestra las opciones para compartir el Book</p>'
      }

    ])
  }

  startBasicTour() {
    {
      const steps = [

        {
          id: "btn-1",
          attachTo: {
            element: '#book-digital-container > app-book-pdf-flipbook-landscape > app-side-options-desktop > div > button.round-button.help',
            //element: '#book-digital-container > app-book-pdf-flipbook-landscape > app-side-options-desktop > div > button.round-button.help.ng-star-inserted',
            on: 'right',
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Finalizar",
              action: () => {

                this.tourService.guideTour.complete();
              }
            }
          ],
          text: "<p>Pulsando este botón se iniciará el Tour de la aplicación</p>",
        }
      ];
      this.tourService.guideTour.addSteps(steps);
      this.tourService.guideTour.start();
    }
  }

  // Comprueba si existe la url del histórico. Si no existe, solicitamos iniciar sesión en el Portal y nos devuelve la url
  showHistoric() {
    if (this.bookService.temporaryToken?.urlHistoric != null && this.bookService.temporaryToken.urlHistoric != '') {
      window.location.href = this.bookService.temporaryToken.urlHistoric;
    } else {
      this.showLogin = !this.showLogin;
    }
  }

  goToPortalLogin() {
    this.configService.getConfig().then(c => {
      const url = `${c.portal_url}/login/professional?r=hce`;
      window.location.href = url;
    });
  }

  goToPortalRegister() {
    this.configService.getConfig().then(c => {
      const url = `${c.portal_url}/mailVerification`;
      window.location.href = url;
    });
  }

  onClickObtainStudy(study: Study) {
    // Renovar token de sesión
    //this.authService.renewUserSessionToken();

    if (!this.obtaining.has(study.studyUID!)) {
      this.obtaining.add(study.studyUID!);
    
      setTimeout(() => {
        if (environment.demo) {
          const interval = setInterval(() => {
            this.obtaining.delete(study.studyUID!);
          }, 75)
        } else {

          this.studiesService.askForStudy(study.studyUID!).then(() => {
            
          }).catch(e => {
            console.error(e)
            setTimeout(() => {
              this.obtaining.delete(study.studyUID!);
              clearInterval(interval);
              this.alertService.alert('Ha ocurrido un error tratando de recuperar el estudio. Contacte con su centro');
            })
          })
          const interval = setInterval(() => {
            this.studiesService.checkStudyStatus(study.studyUID!).subscribe(bol => {
              if(bol){
                this.obtaining.delete(study.studyUID!);
                study.status = 'READY';
                clearInterval(interval);
              }
            })

          }, 7000);

        }
      }, 1200);
    }
  }

}
